export default __webpack_public_path__ + "static/Banner-GiftCards-1-dc78fdb6394c24a041f043560e5a4c96.jpg";